<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-on:submit.prevent="createAccount">
        <v-container>

          <v-row>
            <div v-if="successMessage" class="bg-success my-2" style="width: 100%;">
              {{successMessage}}
            </div>

            <div v-if="errorMessage" class="bg-error my-2" style="width: 100%;">
              {{errorMessage}}
            </div>

            <div v-if="errorTranslatable" class="bg-error my-2" style="width: 100%;">
              {{$replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content)}}
            </div>
          </v-row>



          <v-row>
            <v-text-field
              v-model="salesmanName"
              v-bind:rules="salesmanNameRules"
              label="call agent name"
              prepend-inner-icon="mdi-face-agent"
              variant="solo" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="firstname"
              v-bind:rules="firstnameRules"
              label="first name prospect"
              prepend-inner-icon="mdi-account-box"
              variant="solo" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="lastname"
              v-bind:rules="lastnameRules"
              label="last name prospect"
              prepend-inner-icon="mdi-account-box"
              variant="solo" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="email"
              v-bind:rules="emailRules"
              v-bind:error-messages="emailErrors"
              label="email prospect"
              prepend-inner-icon="mdi-at"
              variant="solo" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="country"
              v-bind:rules="countryRules"
              label="country prospect"
              prepend-inner-icon="mdi-earth"
              variant="solo" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>

          </v-row>

          <v-row class="mt-5">
            <v-btn type="submit" class="bg-primary" block>Create Account</v-btn>
          </v-row>

        </v-container>
      </v-form>

    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import _toLower from 'lodash/toLower'
import Helper from "@/components/helper.js"
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: 'AccountSalesman',
  components: {
    LoginLogo,
  },
  data: function() {
    const namePattern = /^[\p{L}\p{N}\s-]{2,}$/u;

    return {
      errorMessage: "",
      errorTranslatable: null,
      successMessage: "",

      authCode: "",

      salesmanName: "",
      salesmanNameRules: [
        v => !!v || "The name of the call agent is required!",
      ],

      firstname: "",
      firstnameRules: [
        v => !!v || this.$t('menus.createUser.firstnameRequired'),
        v => namePattern.test(v) || this.$t('menus.onBoard.invalidName'),
      ],

      lastname: "",
      lastnameRules: [
        v => !!v || this.$t('menus.createUser.lastnameRequired'),
        v => namePattern.test(v) || this.$t('menus.onBoard.invalidName'),
      ],

      email: "",
      emailErrors: [],
      emailRules: [
        v => !!v || this.$t('menus.createUser.emailRequired'),
        v => Helper.isEmailValid(v) || this.$t('menus.createUser.emailNotValid'),
      ],

      country: "",
      countryRules: [
        v => !!v || 'Country is required!'
      ],

      tempSalesmanName: '',
      tempCountry: '',
    };
  },
  mounted: function() {
    this.authCode = this.$route.query.code;
    if (!this.authCode) {
      this.$router.push('/');
    }
  },
  methods: {
    createAccount: async function() {
      const validForm = await this.$refs.form.validate();
      this.successMessage = '';
      this.errorMessage = '';
      this.errorTranslatable = null;

      if (!validForm.valid) {
        return;
      }

      this.email = _toLower(this.email);

      let onBoardedThrough = 'Web (Salesman Form)';
      if (Helper.isAdobeExtension()) {
        onBoardedThrough = 'Adobe Premier (Salesman Form)';
      }

      if (Helper.isFCPExtension()) {
        onBoardedThrough = 'Final Cut Pro (Salesman Form)';
      }

      const params = {
        authcode: this.authCode,
        salesmanname: this.salesmanName,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        country: this.country,
        onBoardedThrough,
      };

      const authStore = useAuthStore();

      try {
        await authStore.salesmanCreatesTenant(params);
        this.successMessage = "The tenant was created!";
        this.tempSalesmanName = JSON.parse(JSON.stringify(this.salesmanName));
        this.tempCountry = JSON.parse(JSON.stringify(this.country));

        this.$refs.form.reset();

        this.salesmanName = this.tempSalesmanName;
        this.country = this.tempCountry;
      } catch (error) {
        if (error && error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            this.errorTranslatable = apiError;
          } else {
            this.errorMessage = apiError;
          }
        } else {
          this.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      }
    }
  }
}
</script>
